"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLockConfig = void 0;
var DeviceCharacteristic_1 = require("../../../common/DeviceCharacteristic");
var dataViewParsers_1 = require("../parsers/dataViewParsers");
var setLockConfig = function (device, value, withResponse) {
    var boolToNum = function (flag) {
        if (typeof flag === 'number') {
            return flag;
        }
        return flag ? 1 : 0;
    };
    var updatedValue;
    if (typeof value.lockMode === "number") {
        updatedValue = new ArrayBuffer(4);
        var values = new DataView(updatedValue);
        values.setUint8(0, boolToNum(value.locked));
        values.setUint8(1, value.lockMode);
        values.setUint16(2, value.bleTimeout);
        return device
            .writeCharacteristicValues(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.LOCK; }).uuid, values.buffer, withResponse)
            .then(function (response) { return (withResponse ? (0, dataViewParsers_1.parseLockStatus)(response) : response); });
    }
    else if (typeof value.outOfRange === 'boolean') {
        updatedValue = new Uint8Array(2);
        updatedValue.set([boolToNum(value.locked), boolToNum(value.outOfRange)]);
    }
    else {
        updatedValue = Uint8Array.of(boolToNum(value.locked));
    }
    return device
        .writeCharacteristicValues(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.LOCK; }).uuid, updatedValue, withResponse)
        .then(function (response) { return (withResponse ? (0, dataViewParsers_1.parseLockStatus)(response) : response); });
};
exports.setLockConfig = setLockConfig;
